import { Pagination as HeroPagination } from '@heroui/react'
import { useTranslation } from 'react-i18next'

interface PaginationProps {
  page: number;
  total: number;
  onChange: (page: number) => void;
  className?: string;
}

export function Pagination({ page, total, onChange, className = '' }: PaginationProps) {
  const { t } = useTranslation()

  const displayedPage = total ? page : 0

  const displayTotal = Math.max(total, 1)
  const isPaginationDisabled = total <= 1

  return (
    <div className={`flex py-2 ${className}`}>
      <HeroPagination
        className={isPaginationDisabled ? 'opacity-50 pointer-events-none' : ''}
      >
        <HeroPagination.Content>
          <HeroPagination.Item>
            <HeroPagination.Previous
              isDisabled={isPaginationDisabled || displayedPage === 0}
              onPress={() => onChange(page - 1)}
            >
              <HeroPagination.PreviousIcon />
              <span>{t('common.previous')}</span>
            </HeroPagination.Previous>
          </HeroPagination.Item>

          {Array.from({ length: displayTotal }, (_, i) => i).map(p => (
            <HeroPagination.Item key={p}>
              <HeroPagination.Link isActive={p === displayedPage} onPress={() => onChange(p)}>
                {p + 1}
              </HeroPagination.Link>
            </HeroPagination.Item>
          ))}

          <HeroPagination.Item>
            <HeroPagination.Next
              isDisabled={isPaginationDisabled || displayedPage === displayTotal-1}
              onPress={() => onChange(page + 1)}
            >
              <span>{t('common.next')}</span>
              <HeroPagination.NextIcon />
            </HeroPagination.Next>
          </HeroPagination.Item>
        </HeroPagination.Content>
      </HeroPagination>
    </div>
  )
}
